import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Input, Label } from '../';
import Dropdown from '../Dropdown';
import { ORGANIZATION_USER_ROLES } from '../../../constants/userRoles';

/**
 * AdminFields renders form inputs used to collect information
 * about the primary administrator for an organization, including
 * name, phone number, email, and role.
 *
 * It uses react-hook-form for form management and validation.
 */
const AdminFields = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      {/* Admin: full name + phone */}
      <div className="grid grid-cols-2 gap-4">
        {/* Full Name */}
        <div className="form-group">
          <Label variant="gray">Full Name</Label>
          <Input
            variant="primary"
            customClass="!max-w-full"
            placeholder="Jane Doe"
            {...register('primary_admin_full_name', { required: true })}
          />
          {errors.primary_admin_full_name && <p className="error">Required</p>}
        </div>

        {/* Phone Number with basic validation */}
        <div className="form-group">
          <Label variant="gray">Phone Number</Label>
          <Input
            variant="primary"
            customClass="!max-w-full"
            placeholder="+1 (555) 123-4567"
            {...register('primary_admin_phone_number', {
              required: 'Required',
              pattern: {
                value: /^\+?[\d\s\-().]{7,20}$/,
                message: 'Invalid phone',
              },
            })}
          />
          {errors.primary_admin_phone_number && <p className="error">Invalid phone</p>}
        </div>
      </div>

      {/* Row: Email and Role Dropdown */}
      <div className="grid grid-cols-2 gap-4 !mt-[8px]">
        {/* Email with pattern validation */}
        <div className="form-group">
          <Label variant="gray">Email</Label>
          <Input
            variant="primary"
            customClass="!max-w-full"
            placeholder="jane.doe@example.com"
            {...register('primary_admin_email', {
              required: 'Required',
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
                message: 'Invalid email',
              },
            })}
          />
          {errors.primary_admin_email && <p className="error">Invalid email</p>}
        </div>
        {/* Role dropdown with Controller */}
        <div className="form-group">
          <Label variant="gray">Role</Label>
          <Controller
            name="primary_admin_role"
            control={control}
            rules={{ required: true }}
            render={({ field }) => {
              const selectedLabel = ORGANIZATION_USER_ROLES.find(
                (o) => o.value === field.value,
              )?.label;
              return (
                <Dropdown
                  options={ORGANIZATION_USER_ROLES}
                  text="Select the user role"
                  widthClass="w-full"
                  disabled={false}
                  selectedOption={selectedLabel}
                  onSelect={(opt) => field.onChange(opt.value)}
                  onDropdownToggle={() => {}}
                />
              );
            }}
          />
          {errors.primary_admin_role && <p className="error">Required</p>}
        </div>
      </div>
    </>
  );
};

export default AdminFields;
